import { fetchRepairReportV1ControllerGetListByRings } from 'generated/apiComponents';
import { repairReportSyncService } from 'technical/db/sync/repair-report-sync.service';

const PAGE_SIZE = 5;

export const syncRepairReportData = async (
  constructionSiteId: string,
  ringNumberStart: number,
  ringNumberEnd: number,
  headers: any,
) => {
  let page = 0;
  let hasMore = true;

  while (hasMore) {
    const response = await fetchRepairReportV1ControllerGetListByRings({
      pathParams: { constructionSiteId },
      queryParams: {
        ringNumberStart,
        ringNumberEnd,
        paginationPage: page,
        paginationSize: PAGE_SIZE,
      },
      headers,
    });

    const repairs = response?.repairReports ?? [];
    if (repairs.length > 0) {
      await repairReportSyncService.download(repairs);
    }

    if (repairs.length < PAGE_SIZE) {
      hasMore = false;
    } else {
      page++;
    }
  }
};
